export function setVatTypes(state, vatTypes) {
  state.vatTypes = vatTypes;
}

export function setAccounts(state, accounts) {
  state.accounts = accounts;
}

export function setDepartments(state, departments) {
  state.departments = departments;
}

export function setLocations(state, locations) {
  state.locations = locations;
}

export function setWarehouses(state, warehouses) {
  state.warehouses = warehouses;
}

export function setProjects(state, projects) {
  state.projects = projects;
}

export function setDimensionSettings(state, settings) {
  state.dimensionSettings = settings;
}

export function setDimensions(state, dimensions) {
  state.dimensions = dimensions;
}

export function setCurrencies(state, settings) {
  state.currencies = settings;
}

export function setSuppliers(state, settings) {
  state.suppliers = settings;
}

export function setUser(state, user) {
  state.user = user;
}

export function setSettings(state, settings) {
  state.userSettings = settings.userSettings;
  state.companySettings = settings.companySettings;
}
